export default "/dist/files/en_ligne_vide.029c0afaea625234f3d1374a082a6d89.svg";